import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

gsap.registerPlugin(ScrollTrigger);

document.addEventListener("DOMContentLoaded", () => {
  const heroHeading = document.querySelector(".hero-title");
  const heroSubtext = document.querySelector(".hero-subtext");

  gsap.fromTo(
    heroHeading,
    {
      opacity: 0,
      y: 50,
      filter: "blur(5px)",
    },
    {
      opacity: 1,
      y: 0,
      filter: "blur(0px)",
      duration: 1.7,
      ease: "power3.out",
      scrollTrigger: {
        trigger: heroHeading,
        start: "top 80%", // starts when the heading is near the viewport
        toggleActions: "play none none reverse", // animates back when scrolling up
      },
    }
  );

  gsap.fromTo(
    heroSubtext,
    {
      opacity: 0,
      filter: "blur(10px)",
    },
    {
      opacity: 1,
      filter: "blur(0px)",
      duration: 1.8,
      ease: "power3.out",
      scrollTrigger: {
        trigger: heroHeading,
        start: "top 80%", // starts when the heading is near the viewport
        toggleActions: "play none none reverse", // animates back when scrolling up
      },
    }
  );

  gsap.utils.toArray(".service-item").forEach((el,index) => {
    gsap.fromTo(
      el,
      {
        opacity: 0,
        filter: "blur(10px)",
      },
      {
        opacity: 1,
        filter: "blur(0px)",
        duration: 1.9,
        ease: "power3.out",
         delay: index < 2 ? 0.8 : 0,
        scrollTrigger: {
          trigger: el,
          start: "top 80%",
          toggleActions: "play none none reverse",
        },
      }
    );
  });
});
